import React, { useEffect, useState } from 'react';
import { Button, Col, Layout, Row, Typography, notification } from 'antd';
import DocumentsTable from '../../../../components/Admin/Clarifications/DocumentsTable';
import GreetingsTop from '../../../../components/Admin/GreetingsTop/GreetingsTop';
import { useHistory, useParams } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { getDocumentsInfoApi } from '../../../../api/documents';
import { getAccessTokenApi } from '../../../../api/auth';
import { messageErrorGeneral } from '../../../../utils/general';

export default function Documents() {
    const { idNote } = useParams();
    const [documents, setDocuments] = useState(false);
    const [laodingData, setLaodingData] = useState(false);
    const [reloadDocuments, setReloadDocuments] = useState(true);
    const token = getAccessTokenApi();

    useEffect(() => {
        if (token && idNote && reloadDocuments) {
            const data = {
                Reference: idNote,
                documentType: 'NoteDetail',
            };
            setLaodingData(true);
            getDocumentsInfoApi(token, data).then((response) => {
                // console.log(response, "get");
                if (response) {
                    if (response.statusCode === 409) {
                        notification['error']({
                            message: response.message,
                        });

                        setTimeout(() => {
                            window.location.href = '/aclaraciones';
                        }, 1500);
                    }

                    if (response.statusCode === 200) {
                        let result = response.result;
                        result.forEach((element, index) => {
                            element['key'] = index;
                        });
                        setDocuments(result);
                        // setInfoOperation(result[0]);
                    }
                } else {
                    notification['error']({
                        message: messageErrorGeneral(),
                    });

                    setTimeout(() => {
                        window.location.href = '/aclaraciones';
                    }, 1500);
                }
                setLaodingData(false);
                setReloadDocuments(false);
            });
        }
    }, [token, idNote, reloadDocuments]);

    return (
        <Layout>
            <GreetingsTop />

            <HeaderTop />

            <div className="billing__container">
                <DocumentsTable documents={documents} laodingData={laodingData} setReloadDocuments={setReloadDocuments} />
            </div>
        </Layout>
    );
}
function HeaderTop() {
    const { Title } = Typography;
    let history = useHistory();
    return (
        <div className="billing__container">
            <Row xs={24} className="header-top">
                <Col xs={20} md={10} className="header-top__left">
                    <Row>
                        <Title level={3} style={{ marginRight: 20 }}>
                            Archivos
                        </Title>
                    </Row>
                </Col>
                <Col xs={10} md={12} className="header-top__right">
                    <Button type="link" onClick={() => history.goBack()}>
                        <ArrowLeftOutlined /> Atrás
                    </Button>
                </Col>
            </Row>
        </div>
    );
}
